import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import StaffDepartmentsApi from '@/services/apiServiceModules/staffDepartmentsApi.js'
const staffDepartmentsApi = new StaffDepartmentsApi()

export default class StaffDepartmentsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.STAFF_DEPARTMENTS, staffDepartmentsApi, {
			useCache: true,
		})
	}
}
